import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "@blueprintjs/core/lib/css/blueprint.css";
import "flexboxgrid/css/flexboxgrid.min.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
